module.exports = __webpack_public_path__ + "assets/bell-active.96497443.svg";